import React from "react";
import {
  WarmUp,
  MainWorkout,
  FocusIntensity,
  CoolDown,
  RecripeRightIcon,
} from "@utils/defaultImages";
import { ReactComponent as BlueBgCard } from "@assets/images/recipeCardNUmberBg.svg";
import { useTranslation } from "react-i18next";

const ExerciseDescCardView = ({ exercise = {} }) => {
  const { t } = useTranslation();
  const renderHTML = (htmlString) => {
    return { __html: htmlString || "" };
  };
  const nutrientData = [
    {
      label: t("1. Warm Up & Activate"),
      key: "setup",
      icon: <WarmUp className="min-w-[111px] min-h-[111px]" />,
      tabColor: "#F0FFFF",
      value: exercise?.["Warm Up & Activate"],
      number: "01",
    },
    {
      label: t("2. Main Workout"),
      key: "focus",
      icon: <MainWorkout className="min-w-[111px] min-h-[111px]" />,
      tabColor: "#F0FFFF",
      value: exercise?.["Main Workout"],
      number: "02",
    },
    {
      label: t("3. Focus & Intensity Boost"),
      key: "awareness",
      icon: <FocusIntensity className="min-w-[111px] min-h-[111px]" />,
      tabColor: "#F0FFFF",
      value: exercise?.["Focus & Intensity Boost"],
      number: "03",
    },
    {
      label: t("4. Cool Down & Recover"),
      key: "gentle_return",
      icon: <CoolDown className="min-w-[111px] min-h-[111px]" />,
      tabColor: "#F0FFFF",
      value: exercise?.["Cool Down & Recover"],
      number: "04",
    },
  ];

  return (
    <div className="mt-6">
      <div className="space-y-8 md:space-y-12 lg:space-y-[55px] mb-3">
        {nutrientData.map(({ label, icon, value, tabColor, number }, index) => (
          <div
            key={index}
            className="py-4 px-4 sm:py-5 sm:pl-20  lg:pl-[18%] xl:pl-[23%] sm:pr-8 rounded-2xl sm:rounded-[30px] bg-white border border-[#E6E6E6] flex flex-col gap-3 sm:gap-2 relative"
            style={{
              boxShadow: "7px 7px 9.5px 0px #0000000D",
            }}
          >
            {/* Blue Number Background Card - Keep original size on xl */}
            <div className="absolute left-3 sm:left-4 md:left-6 lg:left-8 xl:left-4 2xl:left-12 -bottom-6 sm:-bottom-8 md:-bottom-10 lg:-bottom-[40px] z-10">
              <div className="relative w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-auto xl:h-auto">
                <BlueBgCard className="w-full h-full xl:w-auto xl:h-auto" />
                <div className="absolute inset-0  pl-3 pt-3 xl:pl-8 xl:pt-12 text-white font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[70px]">
                  {number}
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center lg:flex-row lg:items-center lg:justify-between gap-3 sm:gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 sm:gap-3 ml-0 sm:ml-10 md:ml-12 lg:ml-12 xl:ml-12">
                  <div className="flex-shrink-0">
                    <RecripeRightIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <p className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[24px] font-semibold xl:font-[600] text-[#0575e6]">
                    {label}
                  </p>
                </div>
                <div
                  className="text-sm sm:text-[14px] font-medium font-[Lato] text-[#6C6C6C] mt-2 sm:mt-1 ml-0 sm:ml-10 md:ml-12 lg:ml-12 xl:ml-12"
                  style={{
                    wordBreak: "break-word",
                    hyphens: "auto",
                    overflowWrap: "break-word",
                  }}
                >
                  {/* {value?.split("\n").map((line, index) => (
                    <div
                      key={index}
                      className={
                        index > 0
                          ? "border-t border-dashed border-[#E7E7E7] mt-2 pt-2"
                          : ""
                      }
                    >
                      {line}
                    </div>
                  ))} */}
                  {value ? (
                    <div
                      dangerouslySetInnerHTML={renderHTML(value)}
                      className="text-sm sm:text-[14px] font-medium font-[Lato] text-[#6C6C6C]"
                    />
                  ) : (
                    <p className="text-sm sm:text-[14px] font-medium font-[Lato] text-gray-400 italic">
                      {t("No content available")}
                    </p>
                  )}
                </div>
              </div>

              {/* Icon */}
              <div>{icon}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExerciseDescCardView;
